import { customElement, property, state } from "lit/decorators.js";
import { css, html, PropertyValues, TemplateResult } from "lit";
import { LitElement } from "lit";
import { randstr } from "../../util/stringUtils";
import { LitElementBase } from "../LitElementBase";

@customElement("ehm-video")
export class Video extends LitElementBase {
  static styles = css`
    .thumbnailImg {
      aspect-ratio: 1.14 / 1;
      border-radius: var(--radius-2xl);
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
    .video-container {
      position: relative;
    }
    button.play-button {
      background-color: rgba(246, 243, 238, 0.9);
      padding: var(--spacing-15) var(--spacing-40) var(--spacing-15) var(--spacing-15);
      border: 1px solid white;
      display: flex;
      gap: 3px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      border-radius: 999px;
      align-items: center;
      width: max-content;
      cursor: pointer;
      color: var(--text-primary);
      height: 30px;
      box-sizing: content-box;
      &:hover {
        background-color: rgba(246, 243, 238, 1);
      }
    }
  `;

  private buttonId: string;
  private modal: HTMLDialogElement | undefined;
  @property({ type: String }) src = "";
  @property({ type: String }) thumbnailSrc = "";

  constructor() {
    super();
    this.buttonId = randstr("openmodal-");
  }

  firstUpdated(_changedProperties: PropertyValues): void {
    super.firstUpdated(_changedProperties);
    this.modal = this.shadowRoot?.querySelector(
      "#videomodal-" + this.buttonId,
    ) as HTMLDialogElement;
  }

  onClick(e: Event): void {
    e.preventDefault();
    this.modal?.showModal();
  }

  onClose(e: Event): void {
    e.preventDefault();
    this.modal?.close();
  }

  render(): TemplateResult {
    return html` <div class="video-container">
      <img class="thumbnailImg" src="${this.thumbnailSrc}" />
      <button @click=${this.onClick} class="play-button" id="${this.buttonId}">
        <slot name="buttontext"></slot>
      </button>
      <dialog id="videomodal-${this.buttonId}" class="video-modal">
        <div class="modal-content">
          <button class="modal-close" @click=${this.onClose}>
            <ehm-icon name="close"> </ehm-icon>
          </button>
          <slot name="video"></slot>
        </div>
      </dialog>
    </div>`;
  }
}